import { margin, variant } from 'styled-system';
import { LayoutProps, MarginProps, TypographyProps } from '../../../theme/styledProps';
import styled from '../../../theme/theme';
import { Shimmer } from '../Shimmer/Shimmer';
import { ButtonSize, ButtonVariant } from './Button.styles';

interface Props extends MarginProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
}

export const ButtonLoading = styled(Shimmer)<Props>(
  ({ width }) => ({ width }),
  ({ variant: variantProp }) =>
    variant<LayoutProps & TypographyProps, ButtonSize>({
      prop: 'size',
      variants: {
        small: {
          height: variantProp === 'link' ? 'auto' : 24,
          lineHeight: variantProp === 'link' ? 'revert' : '24px',
        },

        medium: {
          height: variantProp === 'link' ? 'auto' : 36,
          lineHeight: variantProp === 'link' ? 'revert' : '36px',
        },

        large: {
          height: variantProp === 'link' ? 'auto' : 48,
          lineHeight: variantProp === 'link' ? 'revert' : '48px',
        },
      },
    }),
  margin,
);

ButtonLoading.defaultProps = {
  variant: 'primary',
  size: 'medium',
};
